import React from 'react';
import { storiesOf } from '@storybook/react';
import { useOverlayScrollbar } from '../useOverlayScrollbar';

const ScrollableContainer = () => {
  const [OverlayScrollbarHostElement, OverlayScrollbarContentElement] =
    useOverlayScrollbar({
      options: { scrollbars: { autoHide: 'never' } },
    });

  return (
    <OverlayScrollbarHostElement style={{ width: '200px', height: '200px' }}>
      <OverlayScrollbarContentElement>
        <div>hello hello hello</div>
        <div>hello hello hello</div>
        <div>hello hello hello</div>
        <div>hello hello hello</div>
        <div>hello hello hello</div>
        <div>hello hello hello</div>
        <div>hello hello hello</div>
        <div>hello hello hello</div>
        <div>hello hello hello</div>
        <div>hello hello hello</div>
        <div>hello hello hello</div>
        <div>hello hello hello</div>
        <div>hello hello hello</div>
      </OverlayScrollbarContentElement>
    </OverlayScrollbarHostElement>
  );
};

storiesOf(`useOverlayScrollbar`, module).add(
  'useOverlayScrollbar',
  ScrollableContainer,
);
